
(function () {
  if (window.__lrAddons) return;
  window.__lrAddons = true;
  console.log('LR addons : script chargé');

  const money = c => (c / 100).toLocaleString('fr-FR', { minimumFractionDigits: 2 }) + ' €';

  function refresh(wrap) {
    const engravingCb = wrap.querySelector('[data-lr-addon="engraving"]');
    const fields = wrap.querySelector('[data-lr-engraving-fields]');
    if (fields) fields.hidden = !(engravingCb && engravingCb.checked);

    const extra = Array.from(wrap.querySelectorAll('input[data-lr-addon]:checked'))
      .reduce((s, cb) => s + (parseInt(cb.dataset.lrAddonPrice, 10) || 0), 0);
    const base = parseInt(wrap.dataset.lrBasePrice, 10) || 0;
    const box = wrap.querySelector('[data-lr-addons-total]');
    const val = wrap.querySelector('[data-lr-addons-total-value]');
    if (box) box.hidden = extra === 0;
    if (val) val.textContent = money(base + extra);
  }

  document.addEventListener('change', (e) => {
    if (!e.target.matches('input[data-lr-addon]')) return;
    refresh(e.target.closest('[data-lr-addons]'));
  });

  let bypass = false;

  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('button[type="submit"], button[name="add"]');
    if (!btn) return;

    // Résolution du formulaire produit :
    // 1. formulaire parent (bouton classique de la fiche)
    // 2. sinon attribut form="..." (bouton d'achat collant, placé hors du <form>)
    let form = btn.closest('form');
    if (!form) {
      const formId = btn.getAttribute('form');
      if (formId) form = document.getElementById(formId);
    }
    if (!form || !/\/cart\/add/.test(form.getAttribute('action') || '')) return;

    if (bypass) { bypass = false; return; }

    const wrap = document.querySelector('[data-lr-addons]');
    if (!wrap) return;
    const addons = Array.from(wrap.querySelectorAll('input[data-lr-addon]:checked'));
    if (!addons.length) return;

    const engravingCb = wrap.querySelector('[data-lr-addon="engraving"]');
    const textInput = wrap.querySelector('[data-lr-engraving-text]');
    if (engravingCb && engravingCb.checked && !textInput.value.trim()) {
      e.preventDefault(); e.stopImmediatePropagation();
      textInput.focus();
      textInput.setCustomValidity('Please enter the text to engrave');
      textInput.reportValidity();
      textInput.setCustomValidity('');
      return;
    }

    e.preventDefault(); e.stopImmediatePropagation();

    const items = addons.map((cb) => {
      const item = { id: parseInt(cb.dataset.lrAddonId, 10), quantity: 1 };
      if (cb.dataset.lrAddon === 'engraving') {
        item.properties = {
          'Engraving text': textInput.value.trim(),
          'Material': wrap.querySelector('[data-lr-engraving-material]').value,
          'Position': wrap.querySelector('[data-lr-engraving-position]').value
        };
      }
      return item;
    });

    try {
      const r = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items })
      });
      if (!r.ok) console.error('LR addons : ajout refusé', await r.text());
    } catch (err) {
      console.error('LR addons : erreur réseau', err);
    }

    bypass = true;
    btn.click();
  }, true);
})();
